/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const Section = styled.section`
  padding: 2rem 1rem;
  @media (min-width: 767px) {
    padding: 3rem 3rem;
  }
  @media (min-width: 1024px) {
    padding: 6rem 4rem;
    padding-bottom: 3rem;
  }
  background-color: ${COLORS.GRAY_50};
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const Card = styled.div`
  cursor: pointer;
  position: relative;
  background-color: ${COLORS.WHITE};
  border-radius: 20px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  max-width: 412px;
  min-height: 250px;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;

  &:hover,
  &:focus-within {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 767px) {
    padding: 1.1rem;
    gap: 1.2rem;
  }
`;


export const IconContainer = styled.div`
  display: flex;
  position: relative;
  padding-left: 10px;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  text-align: left;
`;

export const Title = styled.h3`
  position: relative;
  padding-left: 12px;
  font-size: 24px;
  font-weight: 600;
  color: ${COLORS.DARK_BLUE};
  line-height: 114.9%;
  letter-spacing: 0%;
  @media (min-width: 767px) {
    font-size: 28px;
    letter-spacing: -2px;
  }
`;

export const Description = styled.p`
  position: relative;
  padding-top: 35px;
  padding-left: 15px;
  font-size: 16px;
  color: ${COLORS.GRAY_700};
  line-height: 30px;
  font-weight: 400;
  letter-spacing: 0%;
  @media (min-width: 767px) {
    font-size: 20px;
    letter-spacing: -1px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -1.2rem;
  @media (min-width: 640px) {
    margin-top: 1.5rem;
  }
`;

export const Button = styled.button`
  width: 34px;
  height: 34px;
  border-radius: none;
  background-color: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${COLORS.DARKER_BLUE};
  }
  @media (min-width: 767px) {
    border-radius: 50%;
  }
`;

export const ButtonInner = styled.div`
  background-color: ${COLORS.DARK_BLUE};
  padding: 0.25rem;
  border-radius: 9999px;
  svg {
    background-color: ${COLORS.BLACK};
    width: 1.5rem;
    height: 1.5rem;
  }
`;
